const forest = {
  50: '#EBF0EA',
  100: '#CDD9CC',
  200: '#ACBFAA',
  300: '#8BA587',
  400: '#72926E',
  500: '#597F54',
  600: '#51774d',
  700: '#51774D',
  800: '#3E623A',
  900: '#2E4F29',
  A100: '#A4FF99',
  A200: '#77FF66',
  A400: '#4AFF33',
  A700: '#33FF1A'
};

export default forest;
